import { getFirstPermittedAdminPath } from "../../Util/adminPermissions";
import { RootState } from "../../Redux/store";
import styles from "./Error404.module.scss";
import { useSelector } from "react-redux";
import { Link } from "react-router";
import React from "react";

function Error404() {
  const isAdminRoute = window.location.pathname.includes("/admin");
  const { adminPermissions } = useSelector((state: RootState) => state.auth);

  const homePath = isAdminRoute
    ? getFirstPermittedAdminPath(adminPermissions)
    : "/";

  return (
    <div className={styles.mainContainer}>
      <div className={styles.errorContainer}>
        <h1 className={styles.heading}>404</h1>
        <p className={styles.subHeading}>Page Not Found</p>
        <p className={styles.description}>
          The page you are looking for doesn't exist or an other error occurred.
        </p>
        <div className={styles.linkContainer}>
          <Link className={styles.link} to={homePath}>
            Go to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Error404;
